export default defineNuxtPlugin(nuxtApp => {
  const store = useStore();
  nuxtApp.provide('store', store);
});
